/**
 * Represents the mode of color transformation
 */
export enum CompatibleColorTransformDirection {

    /**
     * Transform from light to dark
     */
    LightToDark = 0,

    /**
     * Transform from dark to light
     */
    DarkToLight = 1,
}
